import { useSelector } from 'react-redux';
import { getActiveUnit } from 'store/units/selectors';
import type { FlowPropertiesInterface, UnitInterface } from 'store/units/types';

export type FlowPropertiesProps = {
  id: string;
  flowProperties: FlowPropertiesInterface;
  activeUnit: UnitInterface;
};

export function withFlowProperties<
  TProps,
  TInjectedKeys extends keyof FlowPropertiesProps,
>(Component: React.JSXElementConstructor<TProps>) {
  return function Injected(props: Omit<TProps, TInjectedKeys>) {
    const activeUnit = useSelector(getActiveUnit);

    if (!activeUnit) {
      return <></>;
    }

    return (
      <Component
        {...(props as TProps)}
        id={activeUnit.key}
        activeUnit={activeUnit}
        flowProperties={activeUnit.flowProperties}
      />
    );
  };
}
